import { Container } from 'inversify-props';
import TYPES from './types';

// Infrastructure
import VueStateManager from './infrastructure/state/vue-state-manager';
import { BusinessActivityDummyRepository } from './infrastructure/repository';

// Application
import { SearchBusinessActivitiesQuery } from './application/queries';

// Domain
import { BusinessActivityRepository } from './domain/repository';
import { StateManager } from './domain/state/state-manager';

export default function setupBusinessActivity(container: Container) {
  container
    .bind<StateManager>(TYPES.CATALOG_KUSPIT_BUSINESS_ACTIVITY_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<BusinessActivityRepository>(TYPES.CATALOG_KUSPIT_BUSINESS_ACTIVITY_REPOSITORY)
    .to(BusinessActivityDummyRepository)
    .inSingletonScope();

  container
    .bind<SearchBusinessActivitiesQuery>(TYPES.SEARCH_CATALOG_KUSPIT_BUSINESS_ACTIVITY_QUERY)
    .to(SearchBusinessActivitiesQuery)
    .inSingletonScope();
}
